import React, {useState } from "react";
import { FormGroup, Form, Container } from "react-bootstrap";
import { Breadcrumb, MainHeader, MainFooter } from "../../components";
import { Input } from 'antd';
import { Link } from "react-router-dom";

function AffiliateLogin() {
    const breadcrumb = [
        {
            path: '/Home',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Log In ',
        },
    ];

    const Eye=()=>{
        if(password==="password"){
            setpassword("text");
            seteye(false);
        }
        else{
            setpassword("password");
            seteye(true);
        }
    }
    const[eye,seteye]=useState(true);
    const[password,setpassword]=useState("password");
    return (
        <>
            <MainHeader />
            <main className="becomePage becomePage_fan becomePage_affiliate">
                <Container>
                    <Breadcrumb title="Log In" breadcrumb={breadcrumb} />
                    <div className="becomePage_inner">
                        <div className="becomePage_signup text-center">
                            <div className="becomePage_head mb-0">
                            <h2 className="mb-0 font-sm">Log In</h2>
                            </div>
                        </div>
                        <div className="becomePage_auth mx-auto">
                            <Form>
                                <FormGroup className="form-group">
                                    <label className="ant-label">Email Or Mobile No.</label>
                                    <Input size="large" placeholder="Email Or Mobile No." value="aditi@mailinator.com" />
                                </FormGroup>
                                <FormGroup className="form-group" >
                                    <label className="ant-label">Password</label>
                                    <div className="position-relative">
                                        <Input type={password}  size="large" placeholder="Password" />
                                        <Link className=" input-icon">         
                                            <i onClick={Eye} className={`fa ${eye ? "gg-eye-off" : "gg-eye-on" }`}></i>
                                        </Link>
                                    </div>
                                </FormGroup>
                                <div className="text-end becomePage_affiliate_txt">
                                    <Link to="/affiliate-forgot-password" className="forgotxt d-inline-block">Forgot Password?</Link>
                                </div>
                                <div className="text-center becomePage_affiliate_btn">
                                    <Link to="/store-profile" className="ms-auto w-100 btn btn-primary btn-lg">Login</Link>
                                </div>
                                <div className="text-center becomePage_affiliate_txt">
                                    Don't have an account? <Link to="/become-a-super-fan" className="forgotxt font-md mb-0 ">Sign Up</Link>
                                </div>
                            </Form>
                        </div>
                    </div>
                </Container>
            </main>
            <MainFooter />
        </>
    );
}

export default AffiliateLogin;